var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-content text-center"},[_c('h1',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.page_title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }